import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    this._onScroll ||= () => this.#checkScroll()
    window.addEventListener('scroll', this._onScroll)
  }

  disconnect() {
    window.removeEventListener('scroll', this._onScroll)
  }

  go () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  #checkScroll() {
    this.#display(window.scrollY > window.innerHeight * 2)
  }

  #display (toggle) {
    this.element.toggleAttribute('show', toggle)
  }
}
